import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetPropertyTypesDocument,
  type GetPropertyTypesQuery,
  type GetPropertyTypesQueryVariables,
} from "~/features/admin/propertySchemas/gqls";

/** Static list of property-type ids supported by the backend. */
export function usePropertyTypes() {
  const { data } = useSuspenseQuery<GetPropertyTypesQuery, GetPropertyTypesQueryVariables>(GetPropertyTypesDocument);
  return data?.propertyTypes ?? [];
}
